// extracted by mini-css-extract-plugin
export default {"title":"I_-z","warning":"J_-z","sizeOptionsLegendText":"K_-z"};